export const FETCH_PROCESS_ARRAY_REQUEST = "FETCH_PROCESS_ARRAY_REQUEST";
export const FETCH_PROCESS_ARRAY_SUCCESS = "FETCH_PROCESS_ARRAY_SUCCESS";
export const FETCH_PROCESS_ARRAY_FAILURE = "FETCH_PROCESS_ARRAY_FAILURE";
